<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="form-group">
                <select class="form-control" v-model="selectedService">
                    <option :value="{ code: service.id , name: service.serviceName, fee: service.serviceFee }" v-for="service in totalService" :key="service.id">
                        {{service.serviceName}}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group">
                <label floater>
                    จำนวนเงิน (บาท) <small class="text-danger">*</small>
                </label>
                <base-input
                    formClasses="mb-0"
                    :input-classes="(submitAddService && $v.tmpService.rate.$error) ? 'is-invalid bd-danger' : '' + ' form-control-alternative hide-arrow'"
                    alternative
                    typeInput="number"
                    placeholder="0"
                    size="lg"
                    v-model="tmpService.rate"
                />
                <div
                    v-if="submitAddService && $v.tmpService.rate.required == false"
                    class="invalid-feedback d-block">กรุณากรอกจำนวนเงิน (บาท)
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group">
                <label floater>
                    ค่าบริการ (บาท) <small class="text-danger">*</small>
                </label>
                <base-input
                    formClasses="mb-0"
                    :input-classes="(submitAddService && $v.tmpService.fee.$error) ? 'is-invalid bd-danger' : '' + ' form-control-alternative hide-arrow'"
                    alternative
                    typeInput="number"
                    placeholder="0"
                    size="lg"
                    v-model="tmpService.fee"
                />
                <div
                    v-if="submitAddService && $v.tmpService.fee.required == false"
                    class="invalid-feedback d-block">กรุณากรอกค่าบริการ (บาท)
                </div>
            </div>
        </div>
        <div class="col-lg-12">
            <div class="form-group">
                <label floater>
                    หมายเหตุ
                </label>
                <textarea
                    class="form-control form-control-sm"
                    rows="3"
                    v-model="tmpService.remark"
                >
                </textarea>
            </div>
        </div>
        <div class="col-lg-12 text-right">
            <b-button variant="outline-primary" class="w-25" @click="backStepService()">
                <i class="fas fa-chevron-left"></i> ย้อนกลับ
            </b-button>
            <b-button type="submit" variant="primary" class="w-25" @click="addServiceToCart()">
                ยืนยัน
            </b-button>
        </div>
    </div>
</template>

<script>
import {
  required
} from "vuelidate/lib/validators";
import {additionalServiceOrderCreate} from "@/api/additionalServices";

export default {
    props:{
        totalService: Object,
        tmpService: Object
    },
    data(){
        return{
            submitAddService: false,
            selectedService: {}
        }
    },
    validations: {
        tmpService: {
            categoryName: { required },
            rate: { required },
            fee: { required  },
        }
    },
    mounted(){
        this.selectedService = {
            code: this.tmpService.code,
            name: this.tmpService.name,
            fee: this.tmpService.fee
        }
    },
    methods: {
        backStepService() {
            this.clearService()
            this.nextStep('CATEGORY')
        },
        clearService() {
            Object.keys(this.tmpService).forEach(key => {
                if( !['categoryCode','categoryName','step'].includes(key) ){
                    this.tmpService[key] = "";
                }
            });
            this.submitAddService = false;
        },
        selectService( service ){
            this.tmpService.code = service.code
            this.tmpService.name = service.name
            this.tmpService.fee = service.fee
        },
        addServiceToCart(){
            this.submitAddService = true;
            this.$v.tmpService.$touch();
            if (this.$v.tmpService.$invalid) {
                return false;
            }
          let senderInfo = JSON.parse(localStorage.getItem('senderInfo'))
          console.log(senderInfo)
          let hasSender = !senderInfo || JSON.stringify(senderInfo) === '{}'?false:true
          let params = {
            serviceId:this.selectedService.code,
            serviceName:this.selectedService.name,
            serviceFee:this.tmpService.fee,
            payFee:this.tmpService.rate,
            cashNum:this.$store.state.cashNum,
            buyerPhone:hasSender?senderInfo.tel:'',
            buyerName:hasSender?senderInfo.name:'',
            buyerProvince:hasSender?senderInfo.province:'',
            buyerCity:hasSender?senderInfo.district:'',
            buyerDistrict:hasSender?senderInfo.state:'',
            buyerAddress:hasSender?senderInfo.address:'',
            buyerPostCode:hasSender?senderInfo.postcode:''
          }
          additionalServiceOrderCreate(params)
              .then((res) => {
                this.$emit('fnGetPosRecentlyList')
                this.clearService();
                this.tmpService.categoryCode = ""
                this.tmpService.categoryName = ""
                this.nextStep( 'FIRST' )
              })
        },
        nextStep( nameStep ){
            this.tmpService.step = nameStep
        },
    },
    watch:{
        selectedService: {
            handler(val){
                this.selectService(val);
            },
            deep: true
        }
    }
}
</script>
